import script from "./UploadArea.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadArea.vue?vue&type=script&setup=true&lang=js"

import "./UploadArea.vue?vue&type=style&index=0&id=6807c4a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6807c4a0"]])

export default __exports__